let urlMode = "atomicpay_path";
let currentSlug = "";

export function configureStorePaths({ mode, storeSlug }) {
  urlMode = mode === "custom_domain" ? "custom_domain" : "atomicpay_path";
  currentSlug = storeSlug || "";
}

export function resolveStoreHref(href, storeSlug = currentSlug) {
  const value = String(href || "").trim();
  if (!value) return "#";
  if (/^(https?:|mailto:|tel:|#)/i.test(value)) return value;
  if (value.startsWith("/")) return storePath(value, storeSlug);
  return value;
}

export function storePath(suffix = "", storeSlug = currentSlug) {
  const path = suffix.startsWith("/") || !suffix ? suffix : `/${suffix}`;
  if (urlMode === "custom_domain") {
    return path || "/";
  }
  return `/commerce/${encodeURIComponent(storeSlug)}${path}`;
}

export function pathToCustom(pathname, storeSlug) {
  const prefix = `/commerce/${storeSlug}`;
  if (pathname === prefix) return "/";
  if (pathname.startsWith(`${prefix}/`)) {
    return pathname.slice(prefix.length) || "/";
  }
  return pathname || "/";
}

export function getStoreUrlMode() {
  return urlMode;
}
